import React, { useCallback } from 'react';
import { LanguageKeys, OpenFileHandle } from '../CommonTypes';

import { FilePckerContainer } from './FilePicker.styles';


export const openFilePicker = (allowedFileTypes: string, allowMultiple: boolean, callBack: (files: FileList) => void) => {
  let fakeInput = document.createElement('input');
  fakeInput.type = 'file';
  fakeInput.accept = allowedFileTypes;
  fakeInput.multiple = allowMultiple;
  fakeInput.addEventListener('change', () => {
    if (fakeInput.files)
      callBack(fakeInput.files);
  }, { once: true });
  fakeInput.click();
};

export type FilePickerPorps = {
  title: string;
  message: string;
  lang: LanguageKeys;
  allowMultiple: boolean;
  allowedFileExtensions: string[];
  onFilesChosen: (files: OpenFileHandle[]) => void;
  openDialog: (title: string, validExtensions: string[], allowMultiple: boolean, lang: LanguageKeys) => Promise<OpenFileHandle[]>;
}


export const FilePicker: React.FC<FilePickerPorps> = ({ title, message, allowMultiple, allowedFileExtensions, lang, onFilesChosen, openDialog }) => {
  const click = useCallback(async () => {
    const files = await openDialog(title, allowedFileExtensions, allowMultiple, lang);
    if (files.length > 0)
      onFilesChosen(files);
  }, [title, allowedFileExtensions, allowMultiple, lang, onFilesChosen, openDialog]);

  return <FilePckerContainer onClick={click}>
    <div>
      <p>{message}</p>
    </div>
  </FilePckerContainer>
};
  
export default FilePicker;